export default "__VITE_ASSET__BlR15fN7__"